import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useContext } from 'react';
import { CruiseCardLocationListBase, CruiseCardLocationListTitle } from '../CruiseCardLocationList/CruiseCardLocationList.styles';
import { CruiseCardDeparturePortProps } from './CruiseCardDeparturePort.types';

function CruiseCardDeparturePort({ departurePort, arrivalPort, variant, packageId }: CruiseCardDeparturePortProps) {
	const { globalization }: any = useContext(CruiseSearchContext);
	const { itineraryCardsDictionary }: any = globalization?.dictionaries || {};
	const { labelRoundtripFrom, labelOnewayFrom, labelToSeparator }: any = itineraryCardsDictionary;

	const isRoundTrip: () => boolean = () => {
		return departurePort.code === arrivalPort.code;
	};

	return (
		<CruiseCardLocationListBase variant={variant} data-testid={`cruise-roundtrip-label-${packageId}`}>
			<CruiseCardLocationListTitle>{isRoundTrip() ? labelRoundtripFrom : labelOnewayFrom}:</CruiseCardLocationListTitle>
			<span>{isRoundTrip() ? `${departurePort.name}` : `${departurePort.name} ${labelToSeparator} ${arrivalPort.name}`}</span>
		</CruiseCardLocationListBase>
	);
}

export default CruiseCardDeparturePort;
